import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard from "./ChartCard";
import ChartTooltip from "./ChartTooltip";
import { axisProps, chart, sentimentLabels, sentimentScale } from "./theme";

function SentimentDistributionChart({ sentiment, style }) {
  const total = sentiment.reduce((sum, s) => sum + s.count, 0);
  const data = sentiment.map((s) => ({
    ...s,
    name: sentimentLabels[s.rating],
    pct: total ? Math.round((s.count / total) * 100) : 0,
  }));

  return (
    <ChartCard
      title="Sentiment breakdown"
      subtitle="Summarised calls by sentiment rating"
      height={240}
      style={style}
      table={{
        columns: ["Rating", "Calls", "Share"],
        rows: data.map((d) => [d.name, d.count, `${d.pct}%`]),
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 18, right: 8, bottom: 0, left: -12 }}
          barCategoryGap="22%"
        >
          <CartesianGrid vertical={false} stroke={chart.grid} />
          <XAxis dataKey="name" interval={0} {...axisProps} />
          <YAxis allowDecimals={false} {...axisProps} axisLine={false} />
          <Tooltip
            cursor={{ fill: chart.cursor }}
            content={
              <ChartTooltip
                rows={(payload) => [
                  {
                    label: "Calls",
                    value: payload[0].payload.count,
                    color: sentimentScale[payload[0].payload.rating],
                  },
                  { label: "Share", value: `${payload[0].payload.pct}%` },
                ]}
              />
            }
          />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {data.map((d) => (
              <Cell key={d.rating} fill={sentimentScale[d.rating]} />
            ))}
            <LabelList
              dataKey="pct"
              position="top"
              formatter={(v) => `${v}%`}
              fill={chart.tick}
              fontSize={12}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}

export default SentimentDistributionChart;
